export const BaseUrl = import.meta.env.VITE_BASE_URL;
export const SentryDsn = import.meta.env.VITE_SENTRY_DSN;
export const Version = import.meta.env.VITE_VERSION;
